export default "__VITE_ASSET__CnvYT78S__"